import essApi from "../axios/essApi";

class ContactService {

    async getContact() {
        return Promise.resolve(essApi.get(`user-contact`));
    }
    async addContact(reqBody) {
        return Promise.resolve(essApi.post(`user-contact`, reqBody));
    }
    async updateContact(reqBody) {
        return Promise.resolve(essApi.put(`user-contact/${reqBody.id}`, reqBody));
    }
    async deleteContact(id) {
        return Promise.resolve(essApi.delete(`user-contact/${id}`));
    }
    async updateProfile(reqBody) {
        return Promise.resolve(essApi.put(`users`, reqBody));
    }
    async getUserByFilter(reqBody) {
        return Promise.resolve(essApi.post(`/users/user-by-filter`, reqBody));
    }
    async getCountry() {
        return Promise.resolve(essApi.get(`countries`));
    }
    async getAllState(countryId) {
        return Promise.resolve(essApi.get(`state/${countryId}`));
    }
    async sendEmail(param) {
        return Promise.resolve(essApi.post(`sendProfile?email=true`, param, {
            responseType: "arraybuffer",
        }));
    }
    async downloadResume(param) {
        return Promise.resolve(essApi.post(`sendProfile`, param, {
            responseType: "arraybuffer",
        }));
    }
}

export default ContactService;